















import { Component, Vue, Model, Emit, Prop } from 'vue-property-decorator';
import { post } from '@/unite/api';
import moment from 'moment';
@Component({
  components: {}
})
export default class EditWhite extends Vue {
  @Prop() data: any;
  mounted() {
    this.dynamicTags = this.data.IpBind;
    this.info.id = this.data.id;
  }
  dialogVisible: boolean = true;
  dynamicTags: any = [];
  inputVisible: boolean = false;
  inputValue: string = '';
  info: any = {
    id: 0,
    ip: '',
    add: true
  };
  handleDelete(tag: any) {
    this.info.add = false;
    this.info.ip = tag;
    post('/back/v1/acct/whitelist', this.info)
      .then(d => {
        this.$message.success('操作成功！');
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      })
      .catch();
  }

  showInput() {
    this.inputVisible = true;
    // @ts-ignore
    this.$nextTick(_ => {
      // @ts-ignore
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }

  handleInputConfirm() {
    if (!this.inputValue) {
      return;
    }
    this.info.add = true;
    this.info.ip = this.inputValue;
    let inputValue = this.inputValue;
    post('/back/v1/acct/whitelist', this.info)
      .then(d => {
        this.$message.success('操作成功！');
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      })
      .catch();
  }
  private handleClose() {
    this.$emit('refesh', true);
  }
}
